import { PostDestination } from 'shared/types'
import { createAction } from '@reduxjs/toolkit'
import { LOGOUT } from 'shared/constants/auth'

export const setComposerProfiles = createAction<PostDestination[]>('composer/setComposerProfiles')
export const logoutAction = createAction(LOGOUT)

export const setTrialStatus = createAction(
  'ACTION_SET_TRIAL_STATUS',
  (payload: { trial: any, status: any, hasChargifyInfo: boolean, chargifySubscriptionId: any }) => ({ payload })
)
